<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Đăng ký hạn hoàn thành
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="200px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Ngày chỉ đạo">
              <el-date-picker
                v-model="form.commandsDate"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                :disabled="true"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Thời hạn hoàn thành" prop="deadline">
              <el-date-picker
                v-model="form.deadline"
                type="date"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                :picker-options="deadlinePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                v-model="form.note"
                type="textarea"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                show-word-limit
                maxlength="5000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import Vue from "vue";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCaseCommandsService from "../../../services/hcCaseCommandsService";
import hcCaseCommandsCommonService from "../../../services/hcCaseCommandsCommonService";

export default {
  name: "hc-command-dk-deadline-dialog",
  props: ["isOpen", "id"],
  mixins: [handleRequestErrorMixin],
  components: {CustomDialog},

  data() {
    return {
      form: {
        commandsDate: null,
        deadline: null,
        note: null
      },
      rules: {
        deadline: null,
        note: null
      },
      hcCaseCommands: null,
      hcCaseCommandsCommon: null,
      deadlinePickerOptions: {
        disabledDate: null
      }
    };
  },

  created() {
    this.initValidationRules();
    this.loadHcCaseCommands()
      .then(() => this.loadHcCaseCommandsCommon())
      .then(() => this.initForm());
  },

  methods: {
    initForm() {
      this.form.commandsDate =
        this.hcCaseCommandsCommon && this.hcCaseCommandsCommon.commandsDate
          ? new Date(this.hcCaseCommandsCommon.commandsDate)
          : null;

      this.deadlinePickerOptions.disabledDate = time =>
        !(
          !this.form.commandsDate ||
          time.getTime() >= this.form.commandsDate.getTime()
        );
    },

    loadHcCaseCommands() {
      return hcCaseCommandsService
        .findById(this.id)
        .then(response => (this.hcCaseCommands = response.data));
    },

    loadHcCaseCommandsCommon() {
      return hcCaseCommandsCommonService
        .findById(this.hcCaseCommands.hcCaseCommandsCommonId)
        .then(response => (this.hcCaseCommandsCommon = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      Vue.set(this.rules, "deadline", [defaultRequiredConstrains]);
    },

    convertToSubmitForm() {
      return {
        deadline: this.form.deadline ? this.form.deadline.getTime() : null,
        note: this.form.note
      };
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({
              message: "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
              type: "error"
            });
          } else {
            resolve();
          }
        });
      });
    },

    save() {
      return this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hcCaseCommandsService
            .dangKyDeadline(this.id, submitForm)
            .then(response => response.data);
        })
        .then(hcCaseCommands => {
          this.$message({
            message: errorMessageFilter({
              errorCode: "hcCommand.dangKyDeadlineSuccess"
            }),
            type: "success"
          });
          this.$emit("success", {result: hcCaseCommands});
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-dk-deadline-dialog.vue